export default __webpack_public_path__ + "static/media/box-dev-concierge.a37f2fae.svg";